"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var Textarea = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, cols = _a.cols, rows = _a.rows, className = _a.className;
    return react_1.default.createElement("textarea", { id: id, name: name, value: value || '', onChange: function (event) { return onChange(event.target.value); }, cols: cols, rows: rows, placeholder: placeholder, className: storybook_1.Helpers.classNames('storybook-forms-textarea', className) });
};
exports.Textarea = Textarea;
exports.Textarea.propTypes = {
    id: prop_types_1.default.string,
    name: prop_types_1.default.string,
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    cols: prop_types_1.default.string,
    row: prop_types_1.default.string,
};
exports.Textarea.defaultProps = {
    cols: '30',
    rows: '3',
};
